import * as React from 'react';
import * as styles from '../Composer.css';
import { LocalizationService } from '../../../services/LocalizationService';
import { inject, observer } from 'mobx-react';
import { Store } from '../stores';
import { IAMessageCategories } from '../../viewer/categories/MessageCategories';
import { IAButton } from '../../button/Button';

export interface IProps {
  store?: Store;
  style?: React.CSSProperties;
}

@inject('store')
@observer
export class CategorySelector extends React.Component<IProps> {
  private readonly localizationService: LocalizationService = new LocalizationService();

  public componentDidMount(): void {
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
  }

  public render(): JSX.Element {
    const style = this.props.style ?? {};
    return (
      <div
        className={styles.IA_composerElement}
        style={{
          cursor: "pointer",
          minHeight: 30,
          width: "calc(100% - 98px)",
          ...style
        }}
        onClick={() => {
          this.props.store.activeComponent = this.props.store.subjects;
        }}
      >
        {this.props.store.instance && this.props.store.instance.settings && this.props.store.instance.settings.categoriesRequired ?
          <div className={styles.IA_label}>{this.localizationService.strings.Messages_PivotCategories} <span style={{ color: this.props.store.highlightColor }}>*</span></div>
          :
          <div className={styles.IA_label}>{this.localizationService.strings.Messages_PivotCategories}</div>
        }
        <div
          className={styles.IA_categories}
          style={{
            border: `1px solid ${this.props.store.activeComponent && this.props.store.activeComponent.type === "subjects" ? (this.props.store.validateSubjects() ? this.props.store.highlightColor : "#df4f4f") : (this.props.store.validateSubjects() ? "transparent" : "#df4f4f")}`
          }}
        >
          {this.props.store.subjects && this.props.store.subjects.categories?.length > 0 &&
            <IAMessageCategories
              categories={this.props.store.subjects.categories}
              fontSlots={this.props.store.fontSlots}
            />
          }
          {this.props.store.subjects && this.props.store.subjects.categories.length === 0 &&
            <IAButton
              label={this.localizationService.strings.Composer_AddSubjects}
              buttonColor="transparent"
              textColor={"#333333"}
              icon="Add"
              height={22}
              iconColor={this.props.store.highlightColor}
              fontSize={14}
              dataAutomationId="subjects-add-new"
              onClick={() => { }}
              style={{
                position: "relative",
                float: "left",
                clear: "both",
                marginLeft: -4,
                padding: 0,
                marginBottom: 5
              }}
            />
          }
        </div>
        {!this.props.store.validateSubjects() &&
          <div
            className={styles.IA_composer_error_message}
            style={{
              clear: "both",
              float: "left"
            }}
          >
            {this.localizationService.strings.Composer_ValidateSubjects}
          </div>
        }
      </div>
    );
  }
}